import { useContext } from 'react';
import { MeContext } from '../context/MeContext';

const SALES_EMAIL = 'sales@passentry.com';
const SUBSCRIPTION_UPGRADE_PATH = '/my-account?openGoLive=1';

export interface UpgradeCta {
  billingEnabled: boolean;
  label: string;
  linkProps: Record<string, unknown>;
}

export const useUpgradeCta = (): UpgradeCta => {
  const meCtx = useContext(MeContext) as {
    state: { billingEnabled: boolean };
  };
  const billingEnabled = meCtx?.state?.billingEnabled === true;

  if (billingEnabled) {
    return {
      billingEnabled,
      label: 'Upgrade plan',
      linkProps: {
        as: 'a',
        href: SUBSCRIPTION_UPGRADE_PATH,
        target: '_blank',
        rel: 'noopener noreferrer',
      },
    };
  }

  return {
    billingEnabled,
    label: 'Talk to sales',
    linkProps: {
      as: 'a',
      href: `mailto:${SALES_EMAIL}`,
      target: '_blank',
      rel: 'noopener noreferrer',
    },
  };
};

export default useUpgradeCta;
